<template>
  <div class="zooid_view">
    <h3>个体练习情况</h3>
    <!-- 搜索 -->
    <div class="waitingcom_title">
      <el-form
        :model="formLabelAlign"
        ref="formLabelAlign"
        label-width="120px"
        :label-position="labelPosition"
      >
        <el-form-item label="科室：">
          <el-select v-model="formLabelAlign.department" @change="handChang">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in departmentArr"
              :key="item.departmentID"
              :label="item.departmentName"
              :value="item.departmentID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职称：">
          <el-select v-model="formLabelAlign.title" @change="handChang">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in titleArr"
              :key="item.pTitle"
              :label="item.pTitle"
              :value="item.pTitle"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="练习状态：">
          <el-select v-model="formLabelAlign.examState" @change="handChang">
            <el-option
              v-for="item in examStateArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 右边搜索栏 -->
      <div class="search_btn">
        <div class="search_left">
          <el-input
            v-model.trim="formLabelAlign.input"
            icon="el-icon-search"
            placeholder="根据考生名称或账号进行搜索"
          ></el-input>
          <i class="el-icon-search"></i>
        </div>
        <div class="query_btn">
          <el-button
            icon="el-icon-search"
            class="searchbtn"
            @click="handleQuery"
            >搜索</el-button
          >
          <el-button
            icon="el-icon-refresh"
            class="searchbtn sonbtn"
            @click="resetForm()"
            >重置</el-button
          >
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="mian_table" v-loading="loading">
      <el-table
        :data="getData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        @sort-change="sortTableFun"
        :default-sort="{ prop: 'score', order: 'descending' }"
        border
      >
        <el-table-column label="序号" type="index" width="60" align="center"
          ><template slot-scope="scope">
            <span>{{ (pageIndex - 1) * eachPageNum + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="作答次数" align="num">
          <template slot-scope="scope">
            <p @click="toNumber(scope.row)" :class="blueState(scope.row)">
              {{ scope.row.practiceTime }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="最近答题用时(分钟)" align="name" width="180">
          <template slot-scope="scope">
            {{ scope.row.spendTime == 0 ? "暂无" : scope.row.spendTime }}
          </template>
        </el-table-column>
        <el-table-column
          label="最近作答情况(已答/总题数)"
          align="name"
          width="210"
        >
          <template slot-scope="scope">
            {{ scope.row.totalNum == 0 ? '/': scope.row.doneNum + "/" + scope.row.totalNum }}
          </template>
        </el-table-column>
        <el-table-column label="最近正确率" align="name" width="100">
          <template slot-scope="scope">
            {{ scope.row.rightRate + "%" }}
          </template>
        </el-table-column>
        <el-table-column
          label="最近练习成绩"
          align="name"
          width="160"
          prop="score"
          sortable
        >
        </el-table-column>
        <el-table-column label="练习状态" align="name" prop="stateHave">
          <template slot-scope="scope">
            <!-- {{ scope.row.isHave == 1 ? "已完成" : "未完成" }} -->
            <!-- 2024/10/21 董修改 -->
            {{scope.row.stateHave}}
            <!-- {{ scope.row.doneNum == scope.row.totalNum  ? "已完成" : "未完成" }} -->
          </template>
        </el-table-column>
        <el-table-column
          label="完成时间"
          width="180"
          align="name"
          prop="submitTime"
          sortable
        >
          <template slot-scope="scope">
            {{ submitTimeFn(scope.row) }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="foot_box">
      <div class="foot_pagetions">
        <p>共有{{ total }}条记录，当前第{{ pageIndex }}/{{ pagesun }}页</p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-size="eachPageNum"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { individualArr, examStatusArr } from "@/state/practiceModel";
import loginvuex from "@/store/index";
import $examApi from "@/api/examApi.js";
export default {
  data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        department: "", // 科室
        title: "", // 职称
        examState: "", // 考试状态
        input: ""
      },
      getDataCondition: {
        input: ""
      },
      departmentArr: [],
      titleArr: [],
      examStateArr: [],
      getData: [], // 数据
      formColumns: [],
      pageIndex: 1, // 起始页
      eachPageNum: 10, // 一页多少条数据
      total: 100,
      loading: false,
      pagesun: "", // 一共多少页
      pagesizesarr: [5, 10, 20, 50, 100],
      custom: "",
      sortType: "score", // 排序类型 score 按成绩排序 submitTime按完成时间排序
      sortState: "asc" // desc 倒序 asc正序
    };
  },
  methods: {
    // 初始化
    Initialize() {
      this.examStateArr = examStatusArr;
      this.formColumns = individualArr;
    },
    // chang查询
    handChang() {
      this.loading = true;
      this.getDatalist();
    },
    // 搜索
    handleQuery() {
      this.pageIndex = 1;
      if (this.formLabelAlign.input) {
        this.getDataCondition.input = this.formLabelAlign.input;
      } else {
        this.getDataCondition.input = "";
      }
      this.loading = true;
      this.getDatalist();
    },
    // 重置
    resetForm(formName) {
      this.formLabelAlign = {
        department: "", // 科室
        title: "", // 职称
        examState: "", // 考试状态
        input: ""
      };
      this.getDatalist();
    },
    // chang查询获取
    async departmentChang() {
      let res = {
        examID: this.$parent.$parent.currentLine.ExamID,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid
      };
      const data = await $examApi.getStuListSearchItems(res);
      if(data.status == 200){
        this.departmentArr = data.data.Data.department; // 科室
        this.titleArr = data.data.Data.ptile; // 职称
      }
      return;
      if (data.status == 200) {
        this.departmentArr = data.data.Data[1]; // 科室
        this.titleArr = data.data.Data[3]; // 职称
      } else {
        this.$message.error(data.message);
      }
    },
    // 表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 分页
    handleSizeChange(val) {
      this.loading = true;
      this.eachPageNum = val;
      this.getDatalist();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.loading = true;
      this.getDatalist();
    },
    //个体练习记录页
    toNumber(row) {
      if (row.isHave == 0) {
        return "";
      } else if (row.isHave == 1) {
        this.$parent.$parent.towCurrentLine = row;
        this.$parent.cutcoms(2);
      }
    },
    // 获取表格
    async getDatalist() {
      let parameter = {
        pageIndex: this.pageIndex - 1, // 页数
        eachPageNum: this.eachPageNum, // 条数
        examID: this.$parent.$parent.currentLine.ExamID, // 试卷ID
        userID: JSON.parse(loginvuex.state.userlist).userID, // 用户ID
        guid: JSON.parse(loginvuex.state.userlist).guid, // token
        departmentID: this.formLabelAlign.department, // 科室ID
        pTitle: this.formLabelAlign.title, // 职称名
        isHave: this.formLabelAlign.examState, // 1 已完成 0未完成(考试状态)
        uesrName: this.formLabelAlign.input, // 考生名字或账号
        sort: this.sortType, // score 按成绩排序 submitTime按完成时间排序
        sortType: this.sortState // desc 倒序 asc正序
      };
      const data = await $examApi.studentsDataList(parameter);
      if (data.status == 200) {
        this.getData = data.data.Data.data;
        this.getData.map(item => {
          for (let ztiem in item) {
            if (item[ztiem] === null) {
              item[ztiem] = 0;
            }
          }
         if (item.doneNum == item.totalNum && item.totalNum!=0){
            item.stateHave = '已完成'
          }else{
            item.stateHave = '未完成'
          }
          item.doneNum1 = item.totalNum == 0 ? '/': item.doneNum + "/" + item.totalNum
          item.rightRate1 = item.rightRate+'%'
          return item;
        });
        this.total = data.data.Data.count;
        this.getData = data.data.Data.data;
        this.pagesun = data.data.Data.pageCount;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      }
    },
    // 排序
    sortTableFun(column) {
      //用户点击这一列的上下排序按钮时，触发的函数
      // this.column = column.prop; //该方法获取到当前列绑定的prop字段名赋值给一个变量，之后这个变量做为入参传给后端
      if (column.prop && column.column.label == "最近练习成绩") {
        //该列有绑定prop字段走这个分支
        if (column.order == "ascending") {
          //当用户点击的是升序按钮，即ascending时
          this.sortState = "asc";
          this.sortType = "score";
        } else if (column.order == "descending") {
          //当用户点击的是降序按钮，即descending时
          this.sortState = "desc";
          this.sortType = "score";
        }
      } else if (column.column.label == "完成时间") {
        // 时间排序
        if (column.order == "ascending" && column.column.label == "完成时间") {
          //当用户点击的是升序按钮，即ascending时
          this.sortState = "asc";
          this.sortType = "submitTime";
        } else if (
          column.order == "descending" &&
          column.column.label == "完成时间"
        ) {
          //当用户点击的是降序按钮，即descending时
          this.sortState = "desc";
          this.sortType = "submitTime";
        }
      }
      this.pageIndex = 1;
      this.getDatalist();
    }
  },
  computed: {
    submitTimeFn() {
      return function(row) {
        // 有可能submitTime为空的情况,取lastTime
        if (row.submitTime == 0) {
          return "暂无";
        } else {
          let time = this.$moment(row.lastTime).format("YYYY/MM/DD HH:mm");
          return time;
        }
      };
    },
    blueState() {
      return function(row) {
        if (row.isHave == 0) {
          return "gray";
        } else if (row.isHave == 1) {
          return "blue";
        }
      };
    }
  },
  created() {
    this.Initialize();
    this.departmentChang();
    this.getDatalist();
  }
};
</script>

<style lang="scss" scoped>
.zooid_view {
  margin-top: 120px;
  h3 {
    letter-spacing: 2px;
  }
  .sorting {
    display: flex;
    align-items: center;
    height: 50px;
    h5 {
      margin: 12px;
    }
    .triangle {
      display: flex;
      align-items: center;
      .box {
        margin-left: 6px;
      }
    }
  }
  // 条件筛选框css
  .waitingcom_title {
    height: 81px;
    padding: 24px 24px 16px 10px;
    border-bottom: 1px solid #f8f8f8;
    display: flex;
    ::v-deep .el-form-item__label {
      margin-left: 24px;
      width: 87px !important;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    ::v-deep .el-form {
      display: flex;
      ::v-deep .el-form-item__content {
        margin-left: 115px !important;
      }
      .el-form-item:nth-child(1) {
        .el-form-item__label {
          margin: 0 !important;
          width: 60px !important;
        }
        .el-form-item__content {
          margin-left: 60px !important;
        }
      }
      ::v-deep .el-input > .el-input__inner {
        width: 168px;
      }
    }
    .search_btn {
      display: flex;
      align-items: center;
      margin-left: 26px;

      .search_left {
        position: relative;
        i {
          position: absolute;
          top: 10px;
          left: 10px;
          font-size: 20px;
        }

        ::v-deep .el-input__inner {
          width: 300px;
          height: 40px;
          padding-left: 36px;
          &::-webkit-input-placeholder {
            padding-left: 10px;
          }
          &:focus {
            border: 1px solid #1890ff;
          }
        }
      }
      .query_btn {
        margin: 0;
        display: flex;
        .el-button {
          width: 88px;
          height: 40px;
          margin-left: 24px;
          &:nth-child(1) {
            background: #1890ff;
            color: #ffffffff;
          }
        }
      }
    }
  }
}
.mian_table {
  background: #ffffffff;
  // height: 700px;
  margin-top: 24px;

  ::v-deep .el-table th:nth-child(1) {
    opacity: 1;
    border-radius: 4px 0px 0px 4px;
  }
  ::v-deep .el-table th:nth-child(13) {
    opacity: 1;
    border-radius: 0px 4px 4px 0px;
  }
  ::v-deep .el-table th > .cell {
    align-items: center !important;
    text-align: center;
  }
  ::v-deep .el-table td > .cell {
    align-items: center !important;
    text-align: center;
  }
  .operation_box {
    ::v-deep .el-button--text {
      font-size: 16px;
      color: #1890ff;
      font-weight: 400;
      &:nth-child(3) {
        color: #ff4747;
      }
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
// 分页
.foot_box {
  position: relative;
  height: 140px;
  ::v-deep .el-pager li:hover {
    color: #1890ff;
  }
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #1890ff;
        border: none;
      }
    }
  }
}

::v-deep .gray {
  color: #cad8d0 !important;
}
::v-deep .blue {
  color: #1890ff !important;
  cursor: pointer;
}
</style>
